import React, { useState, useEffect } from "react";
import axios from "axios";
import loginImage01 from "../../../assets/images/registration/registration-steps-image-04.jpg";
import loginImage02 from "../../../assets/images/registration/registration-steps-image-05.jpg";
import loginImage03 from "../../../assets/images/registration/registration-steps-image-06.jpg";
import { useSelector } from "react-redux";
import { ToastContainer, toast } from 'react-toastify'; // Import react-toastify
import { Endpoints } from "../../../Global/Endpoints";
import { useTranslation } from 'react-i18next';

const ChangePassword = () => {
  const { t, i18n } = useTranslation();
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const contract = useSelector((state) => state.userData);
  const ssoData = useSelector((state) => state.sso.ssoUserData);
  const isHighmarkPortal = ssoData?.Portal === "Highmark";
  const token = localStorage.getItem('AccessToken');

  useEffect(() => {
    const myCarousel = document.querySelector("#carouselExampleSlidesOnly");
    if (myCarousel) {
      new window.bootstrap.Carousel(myCarousel, {
        interval: 5000,
      });
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage('');
    setSuccessMessage('');

    if (newPassword !== confirmPassword) {
      setErrorMessage(t('newpasswordconfirm'));
      return;
    }

    try {
      const response = await axios.post(
        Endpoints.ChangePassword,
        null,  // No data body, as parameters are provided in `params`
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': `Bearer ${token}`,
          },
          params: {
            _Params: JSON.stringify({
              EmailID: contract.userData.EmailID,
              OldPassword: oldPassword,
              NewPassword: newPassword,
              DeviceType: isHighmarkPortal ? "HighmarkPortal" : "PatientPortal"
            }),
          },
        }
      );
 
      // Check if the response is successful
      if (response.data.Result == 1) {
        toast.success(response.data.Message || t('passwordchange'));
        setOldPassword('');
        setNewPassword('');
        setConfirmPassword('');
      } else {
        toast.warning(response.data.Message || t('tryagain'));
      }
    } catch (error) {
      toast.error(error.response?.data?.Message || t('whilechangingpassword'));
    }
  };

  return (
    <>
      <div className="registration-block-main">
        {/* Left Carousel Section */}
        <div className="registration-image-wrapper">
          <div
            id="carouselExampleSlidesOnly"
            className="carousel slide"
            data-bs-ride="carousel"
          >
            <div className="carousel-inner">
              <div className="carousel-item login-carousel-item active" data-bs-interval="5000">
                <img src={loginImage01} alt="" className="registration-image" />
              </div>
              <div className="carousel-item login-carousel-item" data-bs-interval="5000">
                <img src={loginImage02} alt="" className="registration-image" />
              </div>
              <div className="carousel-item login-carousel-item" data-bs-interval="5000">
                <img src={loginImage03} alt="" className="registration-image" />
              </div>
            </div>
          </div>
        </div>
        
        {/* Right Form Section */}
        <div className="registration-form-main">
          <div className="registration-form">
            <h3 className="page-heading-bold">{t('changepassword')}</h3>
            
            <div className="registration-process-form-wrapper mt-5">
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label
                    htmlFor="oldPassword"
                    className="form-label win-form-label mandatory"
                  >
                    {t('oldpassword')}
                  </label>
                  <input
                    type="password"
                    className="form-control win-form-control"
                    id="oldPassword"
                    value={oldPassword}
                    onChange={(e) => setOldPassword(e.target.value)}
                    maxLength="100"
                    aria-describedby="oldPasswordError"
                  />
                </div>
                <div className="mb-3">
                  <label
                    htmlFor="newPassword"
                    className="form-label win-form-label mandatory"
                  >
                    {t('newpassword')}
                  </label>
                  <input
                    type="password"
                    className="form-control win-form-control"
                    id="newPassword"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    maxLength="100"
                    aria-describedby="newPasswordError"
                  />
                </div>
                <div className="mb-3">
                  <label
                    htmlFor="confirmPassword"
                    className="form-label win-form-label mandatory"
                  >
                    {t('confirmpassword')}
                  </label>
                  <input
                    type="password"
                    className="form-control win-form-control"
                    id="confirmPassword"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    maxLength="100"
                    aria-describedby="confirmPasswordError"
                  />
                </div>
                {errorMessage && (
                  <div className="form-field-error-message">{errorMessage}</div>
                )}
                {successMessage && (
                  <div className="form-field-success-message">{successMessage}</div>
                )}
                <div className="mb-3">
                  <button type="submit" className="win-btn-primary mt-4">{t('submit')}</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default ChangePassword;
